import { render, staticRenderFns } from "./AlbumShareZone.vue?vue&type=template&id=ac117642&scoped=true&"
import script from "./AlbumShareZone.vue?vue&type=script&lang=js&"
export * from "./AlbumShareZone.vue?vue&type=script&lang=js&"
import style0 from "./AlbumShareZone.vue?vue&type=style&index=0&id=ac117642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac117642",
  null
  
)

export default component.exports